module.exports = __webpack_public_path__ + "img/emptyspan.5afe4b07.png";